import { render, staticRenderFns } from "./DomainContact.vue?vue&type=template&id=603077b2&scoped=true&"
import script from "./DomainContact.vue?vue&type=script&lang=js&"
export * from "./DomainContact.vue?vue&type=script&lang=js&"
import style0 from "./DomainContact.vue?vue&type=style&index=0&id=603077b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603077b2",
  null
  
)

export default component.exports